import { createNextHook, createStateHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useSettingsState = createStateHook(
  AppStoreProvider,
  state => state.pages.settings
)
export const useNextSettingsState = () =>
  createNextHook(AppStoreProvider, state => state.pages.settings)
